module.exports = __webpack_public_path__ + "img/header-memoireRingsAsWeddingRings.d7bf0fb.jpg";